import React from 'react';
import { useTranslation } from 'react-i18next';
import { ButtonModifiers, CustomButton } from 'Douleutaras/components/CustomButton/CustomButton';

interface PostJobModalFooterProps {
  // Set while the location step shows its inline map picker — swaps the action button for Confirm.
  locationMapView?: { confirmDisabled: boolean };
  nextButtonEnabled?: boolean;
  nextButtonText?: string | React.ReactElement;
  nextButtonDisabled?: boolean;
  onNext(): void;
  onConfirmMap(): void;
}

export const PostJobModalFooter = ({
  locationMapView,
  nextButtonEnabled,
  nextButtonText,
  nextButtonDisabled,
  onNext,
  onConfirmMap
}: PostJobModalFooterProps) => {
  const { t } = useTranslation();

  if (locationMapView) {
    return <div>
      <CustomButton title={t('T.POST-JOB.MAP.CONFIRM-AREA', 'Confirm area')}
                    modifiers={ButtonModifiers.ROUND}
                    onClick={onConfirmMap}
                    disabled={locationMapView.confirmDisabled}
      />
    </div>;
  }

  if (!nextButtonEnabled) {
    return undefined;
  }

  return <div>
    <CustomButton
      title={nextButtonText}
      modifiers={ButtonModifiers.ROUND}
      onClick={onNext}
      disabled={nextButtonDisabled}
    />
  </div>;
};

export default PostJobModalFooter;
